<template>
  <ul
    class="menu"
    v-if="isPortalTypeBooks">
    <li>
      <a
        :href="$getSubdomainLink('portal', '/books/catalog')"
        class="menu__item">
        Books
      </a>
    </li>
  </ul>
  <ul
    class="menu"
    v-else>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/video/catalog')"
        class="menu__item">
        Videos
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/books/catalog')"
        class="menu__item">
        Books
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/blog/catalog')"
        class="menu__item">
        Blog
      </a>
    </li>
  </ul>
  <ul class="menu" v-if="isAuth">
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/chart')"
        class="menu__item">
        Track progress
      </a>
    </li>
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/preferences')"
        class="menu__item">
        My Goals
      </a>
    </li>
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/playlists')"
        class="menu__item">
        My Playlists
      </a>
    </li>
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/video/favorite')"
        class="menu__item">
        My Favorites
      </a>
    </li>
    <li v-else>
      <a
        :href="$getSubdomainLink('portal', '/books/favorite')"
        class="menu__item">
        My Favorites
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/my-profile/personal-info')"
        class="menu__item">
        My Profile
      </a>
    </li>
  </ul>
  <ul class="menu">
    <li v-if="!isAuth">
      <a :href="$getSubdomainLink('portal', '/login')" class="btn btn-menu-link">Log&nbsp;in</a>
    </li>
    <li v-else> 
      <button
        @click="logout"
        class="btn btn-menu-link">
        Log out
      </button>
    </li>
  </ul>
</template>
<script>
  import { useAuthStore, useEnabledStore } from "@/stores";
  export default {
    data() {
      return {
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
      };
    },
    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.portalTypeBooks;
      },
    },
    created() {
      this.checkPortalType();
    },
    methods: {
      logout() {
        this.authStore.logout();
      },
      async checkPortalType() {
        this.enabledStore.checkPortalType();
      },
    },
  };
</script>